export const env = {
    SERVER:"http://ec2-user@ec2-107-23-116-113.compute-1.amazonaws.com:8080"
}